import {
    Hammer,
    TreePine,
    Warehouse,
    Wrench,
} from "lucide-react";

// 4 kerneydelser — alle detaljer er baseret på Nicklas' egen beskrivelse på Facebook.
export const services = [
    {
        id: "renovering",
        icon: Hammer,
        title: "Renovering",
        short:
            "Køkkener, gulve, lofter, døre og vinduer — fra små opdateringer til totalrenovering.",
        description:
            "Jeg hjælper med både mindre opfriskninger og gennemgribende renoveringer. Det kan være nye gulve, nye energieffektive vinduer, et køkken der trænger til en makeover eller en hel entré/bryggers der skal bygges om. Jeg sætter en ære i godt håndværk og ordentligt arbejde — altid med god dialog undervejs.",
        bullets: [
            "Døre & vinduer — bl.a. 3-lags lavenergi-vinduer",
            "Gulve — nye gulve lagt og afsluttet med omhu",
            "Køkkener & inventar — nye eller makeover",
            "Lofter — dampspærre, forskalling, gipsloft og Troldtekt",
            "Forsatsvægge og mindre ombygninger",
        ],
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/asz82r4g_587943745_122093655309146607_6112684363154753602_n.jpg",
    },
    {
        id: "terrasser",
        icon: TreePine,
        title: "Træterrasser & Uderum",
        short:
            "Træterrasser, overdækkede terrasser, hegn og havelåger — bygget til at holde.",
        description:
            "Din terrasse er hjertet af sommeren. Jeg bygger solide træterrasser i trykimprægnerede brædder — store som små — samt overdækkede terrasser, hegn, klatrevægge, havelåger og plankeværk. Altid med korrekt fundament, kvalitetsmaterialer og lige linjer.",
        bullets: [
            "Træterrasser i alle størrelser (inkl. 80+ m² sommerhusterrasser)",
            "Overdækkede terrasser og pergolaer",
            "Hegn, klatrevægge og plankeværk",
            "Havelåger og låger på mål",
        ],
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/18xnz4yp_588431285_122093658075146607_6840024395071549706_n.jpg",
    },
    {
        id: "skure-carporte",
        icon: Warehouse,
        title: "Skure, Carporte & Garager",
        short:
            "Moderne carporte, garager, udhuse og redskabsskure — på mål til din grund.",
        description:
            "Om det er en carport med plads til bilen, en garage, eller et velisoleret skur til redskaberne, så bygger jeg på mål. Jeg står for hele processen — fra fundament og rejsning til tag, beklædning og de sidste detaljer.",
        bullets: [
            "Carporte — enkelt eller dobbelt",
            "Garager bygget på mål",
            "Redskabsskure og haveskure",
            "Udhuse og depoter — med tag og beklædning",
        ],
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/kygerpls_597852311_122104904877146607_2859110013903591007_n.jpg",
    },
    {
        id: "serviceopgaver",
        icon: Wrench,
        title: "Mindre serviceopgaver",
        short:
            "Det der bare skal virke — lister, reparationer, vedligehold og alle de små ting.",
        description:
            "For både private og ejendomme tager jeg gerne de opgaver, der ellers bliver liggende. Udskiftning af lister, reparationer efter fugtskader, løbende vedligehold, eller den mindre tømreropgave der bare skal gøres ordentligt. Pålidelig, fleksibel og altid til en fornuftig pris.",
        bullets: [
            "Udskiftning af lister, karme og fodlister",
            "Reparationer og småopgaver",
            "Løbende vedligehold af ejendomme",
            "Fast håndværker til boligforeninger og udlejere",
        ],
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/1kdaly9y_649509473_122119201023146607_8746944214180891690_n%20%281%29.jpg",
    },
];

// Nicklas' fulde opgaveliste fra Facebook — vises som én samlet "Det kan jeg hjælpe med"-blok.
export const fullTaskList = [
    "Døre & vinduer",
    "Gulve",
    "Træterrasser & overdækkede terrasser",
    "Renovering",
    "Hegn",
    "Køkkener & inventar",
    "Skure, carporte & garager",
    "Mindre serviceopgaver",
];
